import { useCallback } from 'react';

import useUsersList from '@/components/Form/components/VisibilitySettings/components/RestrictedVisibilitySettingsModal/components/RestrictedVisibilitySettingsUsersTab/hooks/useUsersList';
import useVisibilitySettings from '@/components/Form/components/VisibilitySettings/hooks/useVisibilitySettings';

import { RestrictedVisibilitySettingsTabType } from '../../RestrictedVisibilitySettingsGroupsTab/types';

const useRestrictedVisibilitySettingsUsersTab = (
  props: RestrictedVisibilitySettingsTabType & { debounceSearchText: string },
) => {
  const { debounceSearchText, onChange, value } = props;

  const {
    values: { userIds },
    methods: { onRemoveUser, onAddUser },
  } = useVisibilitySettings({ value, onChange });

  const {
    toggleSelectedUserIds: _toggleSelectedUserIds,
    selectedUserIdsSet,
    users,
    fetchingUsers,
    fetchMoreUsers,
  } = useUsersList({
    selectedUserIds: userIds,
    debounceSearchText,
  });

  const toggleSelectedUserIds: ReturnType<typeof useUsersList>['toggleSelectedUserIds'] =
    useCallback(
      (key) => {
        selectedUserIdsSet.has(key)
          ? onRemoveUser({ removedUserId: key })
          : onAddUser({ userId: key });
        _toggleSelectedUserIds(key);
      },
      [onAddUser, onRemoveUser, selectedUserIdsSet, _toggleSelectedUserIds],
    );

  return {
    toggleSelectedUserIds,
    selectedUserIdsSet,
    users,
    fetchingUsers,
    fetchMoreUsers,
  };
};

export default useRestrictedVisibilitySettingsUsersTab;
